import { object, string } from "yup";

const allowedCharsRegex = /^[\p{L}\p{N}\s!"#$%&'()*+,-./:;<=>?@\[\\\]^_`{|}~]*$/u;

export let schema = (t) => 
    object({
      description: string()
      .trim()
      .required(t("validation:required-field"))
      .matches(allowedCharsRegex, t("validation:invalid-characters"))
      ,
    })
